
let apps = {
  "admin.capture672.com" : {
    "title": "Capture672",
    "api": "https://api.capture672.com",
    "awb_email": "ism@cloud.abs5.co.uk"
  },
  "admin-test.capture672.com" : {
    "title": "Capture672",
    "api": "https://api-test.capture672.com"
  },
  "admin.legalworkflow365.com" : {
    "title": "Legal Workflow 365",
    "api": "https://api.legalworkflow365.com"
  },
  "app.legalworkflow365.com" : {
    "title": "Legal Workflow 365",
    "api": "https://api.legalworkflow365.com"
  },
  "admin.legaldocflow.com" : {
    "title": "Legaldocflow",
    "api": "https://api.legaldocflow.com"
  },
  "app.legaldocflow.com" : {
    "title": "Legaldocflow",
    "api": "https://api.legaldocflow.com"
  },
  "tlp.legaldocflow.com" : {
    "title": "Legaldocflow",
    "api": "https://api.legaldocflow.com"
  },
  "admin-test.legalworkflow365.com" : {
    "title": "Legal Workflow 365",
    "api": "https://api-test.legalworkflow365.com"
  },
  "app-pay.taybull.com" : {
    "title": "TaybullPay",
    "api": "https://api-pay.taybull.com"
  },
  "admin-pay.taybull.com" : {
    "title": "TaybullPay",
    "api": "https://api-pay.taybull.com"
  },
  "localhost" : {
    "title": "Taybull ",
    "awb_email": "essa.jabang@taybull.com"
  },
  "app.dataview365.com" : {
    "title": "DataView365",
  },
};


const DomainService = {
  loadTitle(hostname) {
    try {
      let title = apps[hostname].title;
      if(title) {
        document.title = title;
      }

    } catch(err) {
      // 
    }
  },
  getApi(hostname) {
    try {
      let api = apps[hostname].api;
      if(api) {
        return api;
      }

    } catch(err) {
      //
    }
    return null;
  },
  getAWBEmail(hostname) {
    try {
      let value = apps[hostname].awb_email;
      return value;
    } catch(err) {
      //
    }
    return "";
  }
}


export default DomainService;
